const CAST_MAP = {
    dateis: 'equals',
    dateisnot: 'notequals',
    datebefore: 'lessthanorequal',
    dateafter: 'greaterthanorequal'
};

const isEmptyValue = (val) => val === null || val === undefined;

const castDateToString = (val) => {
    const date = new Date(val);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const castFilterToString = (filter, index, key) => {
    const parsedFilters = Object.entries(filter)
        .map(([paramKey, paramValue]) => {
            if (isEmptyValue(paramValue)) {
                return '';
            }

            const encodedValue = encodeURIComponent(filterValue(paramValue));
            return `${key}[${index}].${paramKey}=${encodedValue}`;
        })
        .filter((param) => param.length !== 0)
        .join('&');

    return parsedFilters;
};

const filterValue = (val) => {
    if (val instanceof Date) {
        return castDateToString(val);
    }

    return CAST_MAP[val] || val;
};

/**
 * Convert object to URL parameters.
 *
 * @param {object} params - Parameters to convert.
 * @returns {string} - Proper URL params.
 *
 * @example
 * const url = `transactions?${urlify({
 *      pageSize: 10,
 *      pageNumber: 1,
 *      filters: [{
 *          propertyname: 'partnerName',
 *          value: 'test'
 *      }, {
 *          propertyname: 'commissionType',
 *          value: 'Inbound'
 *      }]
 * })}`
 */
export default (params) => {
    const parsedParams = Object.entries(params)
        .map(([key, value]) => {
            if (isEmptyValue(value)) {
                return '';
            }
            let index = 0;

            if (Array.isArray(value)) {
                return value
                    .map((filter) => {
                        if (isEmptyValue(filter.value) && isEmptyValue(filter.sortorder)) {
                            return '';
                        }
                        const stringifiedFilter = castFilterToString(filter, index, key);
                        index++;
                        return stringifiedFilter;
                    })
                    .filter((param) => param.length !== 0)
                    .join('&');
            }

            const encodedValue = encodeURIComponent(filterValue(value));
            return `${key}=${encodedValue}`;
        })
        .filter((param) => param.length !== 0)
        .join('&');

    return parsedParams;
};
